import React from "react";
import { CheckIcon, TargetIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { volumes } from "../../data/volumes";
export function VolumesSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-366" data-mp="2munccbxfwref">
      <div className="mx-auto max-w-6xl" data-id="element-367" data-mp="2rt6v63gqln2k">
        <SectionHeading eyebrow="What You'll Find Inside" title="6 Specialized Volumes That Take You From Fundamental Concepts to Complete Treatment Review" subtitle="Each volume focuses on a different part of self-ligating orthodontics. Together, they form a connected learning pathway." data-id="element-368" data-mp="2rw2xe3zmaxwt" />

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-369" data-mp="2938qzyg28e47">
          {volumes.map(vol => <article key={vol.numeral} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-card ring-1 ring-navy-900/10" data-id="element-370" data-mp="1v3pn5hua7oxp">
              <div className="bg-navy-900 p-5 sm:p-6" data-id="element-371" data-mp="1z412cf3vkx1s">
                <p className="text-sm font-black uppercase tracking-[0.18em] text-gold" data-id="element-372" data-mp="1fj9z00owoxc6">Volume {vol.numeral}</p>
                <h3 className="mt-2 text-xl font-black leading-tight text-white sm:text-2xl" data-id="element-373" data-mp="1akoys19nmdnq">{vol.title}</h3>
                <p className="mt-2 text-[15px] font-bold text-sky" data-id="element-374" data-mp="1phpsgabeoiou">{vol.tagline}</p>
              </div>
              <div className="flex flex-1 flex-col p-5 sm:p-6" data-id="element-375" data-mp="1ki3gs5b87ai5">
                {vol.intro.map(p => <p key={p} className="mb-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-376" data-mp="wttz9fl1p8wt">
                    {p}
                  </p>)}
                <p className="mt-3 text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-377" data-mp="rruty05qw1x8">Inside, you'll explore:</p>
                <ul className="mt-3 space-y-2" data-id="element-378" data-mp="11s557f87yz9r">
                  {vol.topics.map(t => <li key={t} className="flex items-start gap-2.5 text-[15px] leading-snug text-ink" data-id="element-379" data-mp="e214pgqbvfmz">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-380" data-mp="93g6fmumz616" />
                      {t}
                    </li>)}
                </ul>
                <div className="mt-auto pt-5" data-id="element-381" data-mp="12sf9vdq7w17u">
                  <div className="flex items-start gap-3 rounded-2xl bg-brand-soft p-4" data-id="element-382" data-mp="12r40mye0619c">
                    <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-383" data-mp="17k6xbfe2tqtr" />
                    <p className="text-[15px] leading-snug text-ink" data-id="element-384" data-mp="1chyqsduddl02">
                      <strong className="font-extrabold text-brand" data-id="element-385" data-mp="ftj18hr9fbmy">The objective:</strong> {vol.objective}
                    </p>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCta label="I Want All 6 Volumes Today" data-id="element-386" data-mp="ov8qpi1l00i3" />
      </div>
    </section>;
}